import { on } from 'js/lib/events'
import { createAnalyticsGroup } from 'js/lib/analytics'

const el = '.js-c-header--user-icon-nav--tracking'

on('click', el, event => {
  const anchorElement = event.target.closest(`a${el}`)

  if (anchorElement) {
    const track = createAnalyticsGroup("Header - User icon nav")
    const clickValue = anchorElement.getAttribute('data-name')
    track('click', clickValue)
  }
})
